import { DialogComponent, DialogOpenEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  /** @type {number} */
  #summaryThreshold = 0.5;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  #updateStickyState() {
    const { dialog } = /** @type {Refs} */ (this.refs);
    if (!dialog) return;

    // Refs do not cross nested `*-component` boundaries (e.g., `cart-items-component`), so we query within the dialog.
    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      // Ensure the dialog doesn't get stuck in "unsticky" mode when summary disappears (e.g., empty cart).
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;
    const ratio = summaryHeight / drawerHeight;
    dialog.setAttribute('cart-summary-sticky', ratio > this.#summaryThreshold ? 'false' : 'true');
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}


/* ===============================
   DV - Free Shipping Progress
   =============================== */

(function () {

  function dvMoneyCOP(n) {
    return Number(n).toLocaleString('es-CO');
  }

  async function dvFetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function dvUpdate() {
    const bar = document.querySelector('.dv-ship');
    if (!bar) return;

    const goal = parseInt(bar.dataset.dvGoal);
    const cart = await dvFetchCart();
    const subtotal = Math.round((cart.total_price || 0) / 100);

    const textEl = bar.querySelector('.dv-ship__text--primary');
    const fillEl = bar.querySelector('.dv-ship__fill');
    let truck = bar.querySelector('.dv-ship__truck');

if (!truck) {
  truck = document.createElement('span');
  truck.className = 'dv-ship__truck';
  truck.innerHTML = '🚚';
  bar.querySelector('.dv-ship__meter').appendChild(truck);
}

    const remaining = Math.max(goal - subtotal, 0);
    const pct = Math.max(0, Math.min(100, Math.round((subtotal / goal) * 100)));

    if (remaining > 0) {

  bar.classList.remove('is-complete');

  textEl.innerHTML =
    'Añade <strong>$' +
    dvMoneyCOP(remaining) +
    '</strong> más para que tu <strong>envío sea gratis</strong>!';

} else {

  bar.classList.add('is-complete');

  textEl.innerHTML =
    '¡Tu envío es gratis!';

}

    fillEl.style.width = pct + '%';
    truck.style.left = pct + '%';
  }

  window.dvUpdate = dvUpdate;

  document.addEventListener('DOMContentLoaded', dvUpdate);
  document.addEventListener('cart:updated', dvUpdate);
  document.addEventListener('cart:refresh', dvUpdate);

  /* =========================================
   FORCE UPDATE WHEN DRAWER CHANGES
========================================= */

const drawerObserver = new MutationObserver(() => {
  dvUpdate();
});

const drawerElement = document.querySelector('.cart-drawer__inner');

if (drawerElement) {
  drawerObserver.observe(drawerElement, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.dv-rec-add');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.textContent = 'Agregando...';

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

 fetch('/cart/add', {
  method: 'POST',
  body: formData
})
.then(() => {

  setTimeout(() => {
    dvUpdateCartCount();
  }, 150);

  const drawerInner = document.querySelector('.cart-drawer__inner');
  if (!drawerInner) return;

  return fetch('/?section_id=sections--28151784013905__header_divergente_EPKg4H')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('.cart-drawer__inner');

      if (newDrawer) {
        drawerInner.innerHTML = newDrawer.innerHTML;

        setTimeout(() => {
          dvUpdateCartCount();
        }, 100);
      }
    });

})

  .finally(() => {
    btn.disabled = false;
    btn.textContent = '+ Agregar';
  });
});

})();


document.addEventListener('DOMContentLoaded', function() {
  dvUpdateCartCount();
});

// ===== SINCRONIZAR CONTADOR Y BARRA MÁS RÁPIDO =====

const originalFetch = window.fetch;

window.fetch = async function(...args) {

  const response = await originalFetch.apply(this, args);
  const url = args[0];

  if (typeof url === 'string' && (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update')
    )) {

    try {
      const cloned = response.clone();
      const cart = await cloned.json();

      // Actualizar contador
      if (typeof dvUpdateCartCount === 'function') {
        dvUpdateCartCount();
      }

      // Actualizar barra SIN volver a llamar /cart.js
      if (typeof window.dvUpdate === 'function') {
        window.dvUpdateFromCart(cart);
      }

    } catch (e) {
      // fallback por si no devuelve json
      if (typeof window.dvUpdate === 'function') {
        window.dvUpdate();
      }
    }
  }

  return response;
};

/* ===============================
   OBSERVAR CAMBIOS EN CART PAGE
================================= */

document.addEventListener('DOMContentLoaded', function() {

  const cartContainer = document.querySelector('cart-items');

  if (!cartContainer) return;

  const observer = new MutationObserver(() => {
    if (typeof dvUpdate === 'function') {
      dvUpdate();
    }
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true
  });

});

window.dvUpdateCartCount = function() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const count = cart.item_count || 0;

      const counters = document.querySelectorAll(
        '.dv-cart__count, [data-dv-cart-count]'
      );

      counters.forEach(counter => {
        counter.textContent = count;

        if (count > 0) {
          counter.removeAttribute('hidden');
          counter.style.display = '';
        } else {
          counter.setAttribute('hidden', 'hidden');
          counter.style.display = 'none';
        }
      });

    })
    .catch(err => console.error('Cart sync error:', err));
};

